import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { userApi } from "../lib/api";

const UserAuthContext = createContext(null);

export const UserAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("dnj_user_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await userApi.get("/users/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("dnj_user_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const { data } = await userApi.post("/users/login", { email, password });
    localStorage.setItem("dnj_user_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const register = useCallback(async (email, password, name) => {
    const { data } = await userApi.post("/users/register", { email, password, name });
    localStorage.setItem("dnj_user_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("dnj_user_token");
    setUser(null);
  }, []);

  return (
    <UserAuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </UserAuthContext.Provider>
  );
};

export const useUserAuth = () => {
  const ctx = useContext(UserAuthContext);
  if (!ctx) throw new Error("useUserAuth must be inside UserAuthProvider");
  return ctx;
};
